export default "__VITE_ASSET__77SUXbe0__"